/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as LoginRouteImport } from './routes/login'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as PortalRouteImport } from './routes/portal'
import { Route as PresentRouteImport } from './routes/present'
import { Route as TgRouteImport } from './routes/tg'
import { Route as WorkRouteImport } from './routes/work'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppAbsencesRouteImport } from './routes/_app/absences'
import { Route as AppAdminRouteImport } from './routes/_app/admin'
import { Route as AppAssistantRouteImport } from './routes/_app/assistant'
import { Route as AppFilesRouteImport } from './routes/_app/files'
import { Route as AppInvitationsRouteImport } from './routes/_app/invitations'
import { Route as AppIssuesRouteImport } from './routes/_app/issues'
import { Route as AppMyTasksRouteImport } from './routes/_app/my-tasks'
import { Route as AppNotificationsRouteImport } from './routes/_app/notifications'
import { Route as AppOrgChartRouteImport } from './routes/_app/org-chart'
import { Route as AppPerformanceRouteImport } from './routes/_app/performance'
import { Route as AppPrivacyRouteImport } from './routes/_app/privacy'
import { Route as AppProjectsRouteImport } from './routes/_app/projects'
import { Route as AppSettingsRouteImport } from './routes/_app/settings'
import { Route as AppSystemRouteImport } from './routes/_app/system'
import { Route as AppVelocityRouteImport } from './routes/_app/velocity'
import { Route as ClientInviteTokenRouteImport } from './routes/client-invite.$token'
import { Route as DTokenRouteImport } from './routes/d.$token'
import { Route as DocTokenRouteImport } from './routes/doc.$token'
import { Route as GuestInviteTokenRouteImport } from './routes/guest-invite.$token'
import { Route as STokenRouteImport } from './routes/s.$token'
import { Route as SheetSheetIdRouteImport } from './routes/sheet.$sheetId'
import { Route as AppInviteTokenRouteImport } from './routes/_app/invite.$token'
import { Route as AppJoinTokenRouteImport } from './routes/_app/join.$token'
import { Route as AppOffboardingUserIdRouteImport } from './routes/_app/offboarding.$userId'
import { Route as AppOkrIndexRouteImport } from './routes/_app/okr.index'
import { Route as AppOkrUserIdRouteImport } from './routes/_app/okr.$userId'
import { Route as AppSharedGrantIdRouteImport } from './routes/_app/shared.$grantId'
import { Route as AppSystemAiRouteImport } from './routes/_app/system_.ai'
import { Route as AppSystemAiHarnessRouteImport } from './routes/_app/system_.ai-harness'
import { Route as AppTCodeRouteImport } from './routes/_app/t.$code'
import { Route as AppTeamReportsIndexRouteImport } from './routes/_app/team-reports.index'
import { Route as AppTeamReportsReportIdRouteImport } from './routes/_app/team-reports.$reportId'
import { Route as AppOrgChartMergeInviteTokenRouteImport } from './routes/_app/org-chart_.merge-invite.$token'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const PortalRoute = PortalRouteImport.update({
  id: '/portal',
  path: '/portal',
  getParentRoute: () => rootRouteImport,
} as any)
const PresentRoute = PresentRouteImport.update({
  id: '/present',
  path: '/present',
  getParentRoute: () => rootRouteImport,
} as any)
const TgRoute = TgRouteImport.update({
  id: '/tg',
  path: '/tg',
  getParentRoute: () => rootRouteImport,
} as any)
const WorkRoute = WorkRouteImport.update({
  id: '/work',
  path: '/work',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppAbsencesRoute = AppAbsencesRouteImport.update({
  id: '/absences',
  path: '/absences',
  getParentRoute: () => AppRoute,
} as any)
const AppAdminRoute = AppAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AppRoute,
} as any)
const AppAssistantRoute = AppAssistantRouteImport.update({
  id: '/assistant',
  path: '/assistant',
  getParentRoute: () => AppRoute,
} as any)
const AppFilesRoute = AppFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => AppRoute,
} as any)
const AppInvitationsRoute = AppInvitationsRouteImport.update({
  id: '/invitations',
  path: '/invitations',
  getParentRoute: () => AppRoute,
} as any)
const AppIssuesRoute = AppIssuesRouteImport.update({
  id: '/issues',
  path: '/issues',
  getParentRoute: () => AppRoute,
} as any)
const AppMyTasksRoute = AppMyTasksRouteImport.update({
  id: '/my-tasks',
  path: '/my-tasks',
  getParentRoute: () => AppRoute,
} as any)
const AppNotificationsRoute = AppNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgChartRoute = AppOrgChartRouteImport.update({
  id: '/org-chart',
  path: '/org-chart',
  getParentRoute: () => AppRoute,
} as any)
const AppPerformanceRoute = AppPerformanceRouteImport.update({
  id: '/performance',
  path: '/performance',
  getParentRoute: () => AppRoute,
} as any)
const AppPrivacyRoute = AppPrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => AppRoute,
} as any)
const AppProjectsRoute = AppProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsRoute = AppSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppSystemRoute = AppSystemRouteImport.update({
  id: '/system',
  path: '/system',
  getParentRoute: () => AppRoute,
} as any)
const AppVelocityRoute = AppVelocityRouteImport.update({
  id: '/velocity',
  path: '/velocity',
  getParentRoute: () => AppRoute,
} as any)
const ClientInviteTokenRoute = ClientInviteTokenRouteImport.update({
  id: '/client-invite/$token',
  path: '/client-invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const DTokenRoute = DTokenRouteImport.update({
  id: '/d/$token',
  path: '/d/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const DocTokenRoute = DocTokenRouteImport.update({
  id: '/doc/$token',
  path: '/doc/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const GuestInviteTokenRoute = GuestInviteTokenRouteImport.update({
  id: '/guest-invite/$token',
  path: '/guest-invite/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const STokenRoute = STokenRouteImport.update({
  id: '/s/$token',
  path: '/s/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const SheetSheetIdRoute = SheetSheetIdRouteImport.update({
  id: '/sheet/$sheetId',
  path: '/sheet/$sheetId',
  getParentRoute: () => rootRouteImport,
} as any)
const AppInviteTokenRoute = AppInviteTokenRouteImport.update({
  id: '/invite/$token',
  path: '/invite/$token',
  getParentRoute: () => AppRoute,
} as any)
const AppJoinTokenRoute = AppJoinTokenRouteImport.update({
  id: '/join/$token',
  path: '/join/$token',
  getParentRoute: () => AppRoute,
} as any)
const AppOffboardingUserIdRoute = AppOffboardingUserIdRouteImport.update({
  id: '/offboarding/$userId',
  path: '/offboarding/$userId',
  getParentRoute: () => AppRoute,
} as any)
const AppOkrIndexRoute = AppOkrIndexRouteImport.update({
  id: '/okr/',
  path: '/okr/',
  getParentRoute: () => AppRoute,
} as any)
const AppOkrUserIdRoute = AppOkrUserIdRouteImport.update({
  id: '/okr/$userId',
  path: '/okr/$userId',
  getParentRoute: () => AppRoute,
} as any)
const AppSharedGrantIdRoute = AppSharedGrantIdRouteImport.update({
  id: '/shared/$grantId',
  path: '/shared/$grantId',
  getParentRoute: () => AppRoute,
} as any)
const AppSystemAiRoute = AppSystemAiRouteImport.update({
  id: '/system_/ai',
  path: '/system/ai',
  getParentRoute: () => AppRoute,
} as any)
const AppSystemAiHarnessRoute = AppSystemAiHarnessRouteImport.update({
  id: '/system_/ai-harness',
  path: '/system/ai-harness',
  getParentRoute: () => AppRoute,
} as any)
const AppTCodeRoute = AppTCodeRouteImport.update({
  id: '/t/$code',
  path: '/t/$code',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamReportsIndexRoute = AppTeamReportsIndexRouteImport.update({
  id: '/team-reports/',
  path: '/team-reports/',
  getParentRoute: () => AppRoute,
} as any)
const AppTeamReportsReportIdRoute = AppTeamReportsReportIdRouteImport.update({
  id: '/team-reports/$reportId',
  path: '/team-reports/$reportId',
  getParentRoute: () => AppRoute,
} as any)
const AppOrgChartMergeInviteTokenRoute =
  AppOrgChartMergeInviteTokenRouteImport.update({
    id: '/org-chart_/merge-invite/$token',
    path: '/org-chart/merge-invite/$token',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/portal': typeof PortalRoute
  '/present': typeof PresentRoute
  '/tg': typeof TgRoute
  '/work': typeof WorkRoute
  '/absences': typeof AppAbsencesRoute
  '/admin': typeof AppAdminRoute
  '/assistant': typeof AppAssistantRoute
  '/files': typeof AppFilesRoute
  '/invitations': typeof AppInvitationsRoute
  '/issues': typeof AppIssuesRoute
  '/my-tasks': typeof AppMyTasksRoute
  '/notifications': typeof AppNotificationsRoute
  '/org-chart': typeof AppOrgChartRoute
  '/performance': typeof AppPerformanceRoute
  '/privacy': typeof AppPrivacyRoute
  '/projects': typeof AppProjectsRoute
  '/settings': typeof AppSettingsRoute
  '/system': typeof AppSystemRoute
  '/velocity': typeof AppVelocityRoute
  '/client-invite/$token': typeof ClientInviteTokenRoute
  '/d/$token': typeof DTokenRoute
  '/doc/$token': typeof DocTokenRoute
  '/guest-invite/$token': typeof GuestInviteTokenRoute
  '/s/$token': typeof STokenRoute
  '/sheet/$sheetId': typeof SheetSheetIdRoute
  '/invite/$token': typeof AppInviteTokenRoute
  '/join/$token': typeof AppJoinTokenRoute
  '/offboarding/$userId': typeof AppOffboardingUserIdRoute
  '/okr/$userId': typeof AppOkrUserIdRoute
  '/shared/$grantId': typeof AppSharedGrantIdRoute
  '/system/ai': typeof AppSystemAiRoute
  '/system/ai-harness': typeof AppSystemAiHarnessRoute
  '/t/$code': typeof AppTCodeRoute
  '/team-reports/$reportId': typeof AppTeamReportsReportIdRoute
  '/okr/': typeof AppOkrIndexRoute
  '/team-reports/': typeof AppTeamReportsIndexRoute
  '/org-chart/merge-invite/$token': typeof AppOrgChartMergeInviteTokenRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/portal': typeof PortalRoute
  '/present': typeof PresentRoute
  '/tg': typeof TgRoute
  '/work': typeof WorkRoute
  '/absences': typeof AppAbsencesRoute
  '/admin': typeof AppAdminRoute
  '/assistant': typeof AppAssistantRoute
  '/files': typeof AppFilesRoute
  '/invitations': typeof AppInvitationsRoute
  '/issues': typeof AppIssuesRoute
  '/my-tasks': typeof AppMyTasksRoute
  '/notifications': typeof AppNotificationsRoute
  '/org-chart': typeof AppOrgChartRoute
  '/performance': typeof AppPerformanceRoute
  '/privacy': typeof AppPrivacyRoute
  '/projects': typeof AppProjectsRoute
  '/settings': typeof AppSettingsRoute
  '/system': typeof AppSystemRoute
  '/velocity': typeof AppVelocityRoute
  '/client-invite/$token': typeof ClientInviteTokenRoute
  '/d/$token': typeof DTokenRoute
  '/doc/$token': typeof DocTokenRoute
  '/guest-invite/$token': typeof GuestInviteTokenRoute
  '/s/$token': typeof STokenRoute
  '/sheet/$sheetId': typeof SheetSheetIdRoute
  '/': typeof AppIndexRoute
  '/invite/$token': typeof AppInviteTokenRoute
  '/join/$token': typeof AppJoinTokenRoute
  '/offboarding/$userId': typeof AppOffboardingUserIdRoute
  '/okr/$userId': typeof AppOkrUserIdRoute
  '/shared/$grantId': typeof AppSharedGrantIdRoute
  '/system/ai': typeof AppSystemAiRoute
  '/system/ai-harness': typeof AppSystemAiHarnessRoute
  '/t/$code': typeof AppTCodeRoute
  '/team-reports/$reportId': typeof AppTeamReportsReportIdRoute
  '/okr': typeof AppOkrIndexRoute
  '/team-reports': typeof AppTeamReportsIndexRoute
  '/org-chart/merge-invite/$token': typeof AppOrgChartMergeInviteTokenRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/login': typeof LoginRoute
  '/onboarding': typeof OnboardingRoute
  '/portal': typeof PortalRoute
  '/present': typeof PresentRoute
  '/tg': typeof TgRoute
  '/work': typeof WorkRoute
  '/_app/absences': typeof AppAbsencesRoute
  '/_app/admin': typeof AppAdminRoute
  '/_app/assistant': typeof AppAssistantRoute
  '/_app/files': typeof AppFilesRoute
  '/_app/invitations': typeof AppInvitationsRoute
  '/_app/issues': typeof AppIssuesRoute
  '/_app/my-tasks': typeof AppMyTasksRoute
  '/_app/notifications': typeof AppNotificationsRoute
  '/_app/org-chart': typeof AppOrgChartRoute
  '/_app/performance': typeof AppPerformanceRoute
  '/_app/privacy': typeof AppPrivacyRoute
  '/_app/projects': typeof AppProjectsRoute
  '/_app/settings': typeof AppSettingsRoute
  '/_app/system': typeof AppSystemRoute
  '/_app/velocity': typeof AppVelocityRoute
  '/client-invite/$token': typeof ClientInviteTokenRoute
  '/d/$token': typeof DTokenRoute
  '/doc/$token': typeof DocTokenRoute
  '/guest-invite/$token': typeof GuestInviteTokenRoute
  '/s/$token': typeof STokenRoute
  '/sheet/$sheetId': typeof SheetSheetIdRoute
  '/_app/': typeof AppIndexRoute
  '/_app/invite/$token': typeof AppInviteTokenRoute
  '/_app/join/$token': typeof AppJoinTokenRoute
  '/_app/offboarding/$userId': typeof AppOffboardingUserIdRoute
  '/_app/okr/$userId': typeof AppOkrUserIdRoute
  '/_app/shared/$grantId': typeof AppSharedGrantIdRoute
  '/_app/system_/ai': typeof AppSystemAiRoute
  '/_app/system_/ai-harness': typeof AppSystemAiHarnessRoute
  '/_app/t/$code': typeof AppTCodeRoute
  '/_app/team-reports/$reportId': typeof AppTeamReportsReportIdRoute
  '/_app/okr/': typeof AppOkrIndexRoute
  '/_app/team-reports/': typeof AppTeamReportsIndexRoute
  '/_app/org-chart_/merge-invite/$token': typeof AppOrgChartMergeInviteTokenRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/onboarding'
    | '/portal'
    | '/present'
    | '/tg'
    | '/work'
    | '/absences'
    | '/admin'
    | '/assistant'
    | '/files'
    | '/invitations'
    | '/issues'
    | '/my-tasks'
    | '/notifications'
    | '/org-chart'
    | '/performance'
    | '/privacy'
    | '/projects'
    | '/settings'
    | '/system'
    | '/velocity'
    | '/client-invite/$token'
    | '/d/$token'
    | '/doc/$token'
    | '/guest-invite/$token'
    | '/s/$token'
    | '/sheet/$sheetId'
    | '/invite/$token'
    | '/join/$token'
    | '/offboarding/$userId'
    | '/okr/$userId'
    | '/shared/$grantId'
    | '/system/ai'
    | '/system/ai-harness'
    | '/t/$code'
    | '/team-reports/$reportId'
    | '/okr/'
    | '/team-reports/'
    | '/org-chart/merge-invite/$token'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/onboarding'
    | '/portal'
    | '/present'
    | '/tg'
    | '/work'
    | '/absences'
    | '/admin'
    | '/assistant'
    | '/files'
    | '/invitations'
    | '/issues'
    | '/my-tasks'
    | '/notifications'
    | '/org-chart'
    | '/performance'
    | '/privacy'
    | '/projects'
    | '/settings'
    | '/system'
    | '/velocity'
    | '/client-invite/$token'
    | '/d/$token'
    | '/doc/$token'
    | '/guest-invite/$token'
    | '/s/$token'
    | '/sheet/$sheetId'
    | '/'
    | '/invite/$token'
    | '/join/$token'
    | '/offboarding/$userId'
    | '/okr/$userId'
    | '/shared/$grantId'
    | '/system/ai'
    | '/system/ai-harness'
    | '/t/$code'
    | '/team-reports/$reportId'
    | '/okr'
    | '/team-reports'
    | '/org-chart/merge-invite/$token'
  id:
    | '__root__'
    | '/_app'
    | '/login'
    | '/onboarding'
    | '/portal'
    | '/present'
    | '/tg'
    | '/work'
    | '/_app/absences'
    | '/_app/admin'
    | '/_app/assistant'
    | '/_app/files'
    | '/_app/invitations'
    | '/_app/issues'
    | '/_app/my-tasks'
    | '/_app/notifications'
    | '/_app/org-chart'
    | '/_app/performance'
    | '/_app/privacy'
    | '/_app/projects'
    | '/_app/settings'
    | '/_app/system'
    | '/_app/velocity'
    | '/client-invite/$token'
    | '/d/$token'
    | '/doc/$token'
    | '/guest-invite/$token'
    | '/s/$token'
    | '/sheet/$sheetId'
    | '/_app/'
    | '/_app/invite/$token'
    | '/_app/join/$token'
    | '/_app/offboarding/$userId'
    | '/_app/okr/$userId'
    | '/_app/shared/$grantId'
    | '/_app/system_/ai'
    | '/_app/system_/ai-harness'
    | '/_app/t/$code'
    | '/_app/team-reports/$reportId'
    | '/_app/okr/'
    | '/_app/team-reports/'
    | '/_app/org-chart_/merge-invite/$token'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginRoute: typeof LoginRoute
  OnboardingRoute: typeof OnboardingRoute
  PortalRoute: typeof PortalRoute
  PresentRoute: typeof PresentRoute
  TgRoute: typeof TgRoute
  WorkRoute: typeof WorkRoute
  ClientInviteTokenRoute: typeof ClientInviteTokenRoute
  DTokenRoute: typeof DTokenRoute
  DocTokenRoute: typeof DocTokenRoute
  GuestInviteTokenRoute: typeof GuestInviteTokenRoute
  STokenRoute: typeof STokenRoute
  SheetSheetIdRoute: typeof SheetSheetIdRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portal': {
      id: '/portal'
      path: '/portal'
      fullPath: '/portal'
      preLoaderRoute: typeof PortalRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/present': {
      id: '/present'
      path: '/present'
      fullPath: '/present'
      preLoaderRoute: typeof PresentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tg': {
      id: '/tg'
      path: '/tg'
      fullPath: '/tg'
      preLoaderRoute: typeof TgRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/work': {
      id: '/work'
      path: '/work'
      fullPath: '/work'
      preLoaderRoute: typeof WorkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/absences': {
      id: '/_app/absences'
      path: '/absences'
      fullPath: '/absences'
      preLoaderRoute: typeof AppAbsencesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/admin': {
      id: '/_app/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AppAdminRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/assistant': {
      id: '/_app/assistant'
      path: '/assistant'
      fullPath: '/assistant'
      preLoaderRoute: typeof AppAssistantRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/files': {
      id: '/_app/files'
      path: '/files'
      fullPath: '/files'
      preLoaderRoute: typeof AppFilesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/invitations': {
      id: '/_app/invitations'
      path: '/invitations'
      fullPath: '/invitations'
      preLoaderRoute: typeof AppInvitationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/issues': {
      id: '/_app/issues'
      path: '/issues'
      fullPath: '/issues'
      preLoaderRoute: typeof AppIssuesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-tasks': {
      id: '/_app/my-tasks'
      path: '/my-tasks'
      fullPath: '/my-tasks'
      preLoaderRoute: typeof AppMyTasksRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/notifications': {
      id: '/_app/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AppNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/org-chart': {
      id: '/_app/org-chart'
      path: '/org-chart'
      fullPath: '/org-chart'
      preLoaderRoute: typeof AppOrgChartRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/performance': {
      id: '/_app/performance'
      path: '/performance'
      fullPath: '/performance'
      preLoaderRoute: typeof AppPerformanceRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/privacy': {
      id: '/_app/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof AppPrivacyRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/projects': {
      id: '/_app/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof AppProjectsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings': {
      id: '/_app/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AppSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/system': {
      id: '/_app/system'
      path: '/system'
      fullPath: '/system'
      preLoaderRoute: typeof AppSystemRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/velocity': {
      id: '/_app/velocity'
      path: '/velocity'
      fullPath: '/velocity'
      preLoaderRoute: typeof AppVelocityRouteImport
      parentRoute: typeof AppRoute
    }
    '/client-invite/$token': {
      id: '/client-invite/$token'
      path: '/client-invite/$token'
      fullPath: '/client-invite/$token'
      preLoaderRoute: typeof ClientInviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/d/$token': {
      id: '/d/$token'
      path: '/d/$token'
      fullPath: '/d/$token'
      preLoaderRoute: typeof DTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/doc/$token': {
      id: '/doc/$token'
      path: '/doc/$token'
      fullPath: '/doc/$token'
      preLoaderRoute: typeof DocTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/guest-invite/$token': {
      id: '/guest-invite/$token'
      path: '/guest-invite/$token'
      fullPath: '/guest-invite/$token'
      preLoaderRoute: typeof GuestInviteTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$token': {
      id: '/s/$token'
      path: '/s/$token'
      fullPath: '/s/$token'
      preLoaderRoute: typeof STokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sheet/$sheetId': {
      id: '/sheet/$sheetId'
      path: '/sheet/$sheetId'
      fullPath: '/sheet/$sheetId'
      preLoaderRoute: typeof SheetSheetIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/invite/$token': {
      id: '/_app/invite/$token'
      path: '/invite/$token'
      fullPath: '/invite/$token'
      preLoaderRoute: typeof AppInviteTokenRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/join/$token': {
      id: '/_app/join/$token'
      path: '/join/$token'
      fullPath: '/join/$token'
      preLoaderRoute: typeof AppJoinTokenRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/offboarding/$userId': {
      id: '/_app/offboarding/$userId'
      path: '/offboarding/$userId'
      fullPath: '/offboarding/$userId'
      preLoaderRoute: typeof AppOffboardingUserIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/okr/': {
      id: '/_app/okr/'
      path: '/okr'
      fullPath: '/okr/'
      preLoaderRoute: typeof AppOkrIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/okr/$userId': {
      id: '/_app/okr/$userId'
      path: '/okr/$userId'
      fullPath: '/okr/$userId'
      preLoaderRoute: typeof AppOkrUserIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/shared/$grantId': {
      id: '/_app/shared/$grantId'
      path: '/shared/$grantId'
      fullPath: '/shared/$grantId'
      preLoaderRoute: typeof AppSharedGrantIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/system_/ai': {
      id: '/_app/system_/ai'
      path: '/system/ai'
      fullPath: '/system/ai'
      preLoaderRoute: typeof AppSystemAiRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/system_/ai-harness': {
      id: '/_app/system_/ai-harness'
      path: '/system/ai-harness'
      fullPath: '/system/ai-harness'
      preLoaderRoute: typeof AppSystemAiHarnessRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/t/$code': {
      id: '/_app/t/$code'
      path: '/t/$code'
      fullPath: '/t/$code'
      preLoaderRoute: typeof AppTCodeRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team-reports/': {
      id: '/_app/team-reports/'
      path: '/team-reports'
      fullPath: '/team-reports/'
      preLoaderRoute: typeof AppTeamReportsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/team-reports/$reportId': {
      id: '/_app/team-reports/$reportId'
      path: '/team-reports/$reportId'
      fullPath: '/team-reports/$reportId'
      preLoaderRoute: typeof AppTeamReportsReportIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/org-chart_/merge-invite/$token': {
      id: '/_app/org-chart_/merge-invite/$token'
      path: '/org-chart/merge-invite/$token'
      fullPath: '/org-chart/merge-invite/$token'
      preLoaderRoute: typeof AppOrgChartMergeInviteTokenRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAbsencesRoute: typeof AppAbsencesRoute
  AppAdminRoute: typeof AppAdminRoute
  AppAssistantRoute: typeof AppAssistantRoute
  AppFilesRoute: typeof AppFilesRoute
  AppInvitationsRoute: typeof AppInvitationsRoute
  AppIssuesRoute: typeof AppIssuesRoute
  AppMyTasksRoute: typeof AppMyTasksRoute
  AppNotificationsRoute: typeof AppNotificationsRoute
  AppOrgChartRoute: typeof AppOrgChartRoute
  AppPerformanceRoute: typeof AppPerformanceRoute
  AppPrivacyRoute: typeof AppPrivacyRoute
  AppProjectsRoute: typeof AppProjectsRoute
  AppSettingsRoute: typeof AppSettingsRoute
  AppSystemRoute: typeof AppSystemRoute
  AppVelocityRoute: typeof AppVelocityRoute
  AppIndexRoute: typeof AppIndexRoute
  AppInviteTokenRoute: typeof AppInviteTokenRoute
  AppJoinTokenRoute: typeof AppJoinTokenRoute
  AppOffboardingUserIdRoute: typeof AppOffboardingUserIdRoute
  AppOkrUserIdRoute: typeof AppOkrUserIdRoute
  AppSharedGrantIdRoute: typeof AppSharedGrantIdRoute
  AppSystemAiRoute: typeof AppSystemAiRoute
  AppSystemAiHarnessRoute: typeof AppSystemAiHarnessRoute
  AppTCodeRoute: typeof AppTCodeRoute
  AppTeamReportsReportIdRoute: typeof AppTeamReportsReportIdRoute
  AppOkrIndexRoute: typeof AppOkrIndexRoute
  AppTeamReportsIndexRoute: typeof AppTeamReportsIndexRoute
  AppOrgChartMergeInviteTokenRoute: typeof AppOrgChartMergeInviteTokenRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAbsencesRoute: AppAbsencesRoute,
  AppAdminRoute: AppAdminRoute,
  AppAssistantRoute: AppAssistantRoute,
  AppFilesRoute: AppFilesRoute,
  AppInvitationsRoute: AppInvitationsRoute,
  AppIssuesRoute: AppIssuesRoute,
  AppMyTasksRoute: AppMyTasksRoute,
  AppNotificationsRoute: AppNotificationsRoute,
  AppOrgChartRoute: AppOrgChartRoute,
  AppPerformanceRoute: AppPerformanceRoute,
  AppPrivacyRoute: AppPrivacyRoute,
  AppProjectsRoute: AppProjectsRoute,
  AppSettingsRoute: AppSettingsRoute,
  AppSystemRoute: AppSystemRoute,
  AppVelocityRoute: AppVelocityRoute,
  AppIndexRoute: AppIndexRoute,
  AppInviteTokenRoute: AppInviteTokenRoute,
  AppJoinTokenRoute: AppJoinTokenRoute,
  AppOffboardingUserIdRoute: AppOffboardingUserIdRoute,
  AppOkrUserIdRoute: AppOkrUserIdRoute,
  AppSharedGrantIdRoute: AppSharedGrantIdRoute,
  AppSystemAiRoute: AppSystemAiRoute,
  AppSystemAiHarnessRoute: AppSystemAiHarnessRoute,
  AppTCodeRoute: AppTCodeRoute,
  AppTeamReportsReportIdRoute: AppTeamReportsReportIdRoute,
  AppOkrIndexRoute: AppOkrIndexRoute,
  AppTeamReportsIndexRoute: AppTeamReportsIndexRoute,
  AppOrgChartMergeInviteTokenRoute: AppOrgChartMergeInviteTokenRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginRoute: LoginRoute,
  OnboardingRoute: OnboardingRoute,
  PortalRoute: PortalRoute,
  PresentRoute: PresentRoute,
  TgRoute: TgRoute,
  WorkRoute: WorkRoute,
  ClientInviteTokenRoute: ClientInviteTokenRoute,
  DTokenRoute: DTokenRoute,
  DocTokenRoute: DocTokenRoute,
  GuestInviteTokenRoute: GuestInviteTokenRoute,
  STokenRoute: STokenRoute,
  SheetSheetIdRoute: SheetSheetIdRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
